module.exports = __webpack_public_path__ + "static/img/table2.8c5a3073.png";